import { getProductPrice, isProductSubmission } from '../utils';
export function valueEqual(givenValue, expectedValue) {
    if (isProductSubmission(givenValue)) {
        return getProductPrice(givenValue) === expectedValue;
    }
    return givenValue === expectedValue;
}

//# sourceMappingURL=equal.js.map